import { Link } from 'react-router-dom';
import { slugify } from '../slug';
import type { VideoMeta } from '../youtube';

interface Props {
  video: VideoMeta;
}

export default function VideoCard({ video }: Props) {
  const slug = slugify(video.title);
  // YouTube hands out multiple thumbnails: default (120×90, 4:3),
  // medium (320×180, 16:9), high (480×360, 4:3 — letterboxed!),
  // standard (640×480, 4:3) and maxres (1280×720, 16:9, when available).
  // Pick a 16:9 variant first so the card has no black bars; CSS still uses
  // object-fit: cover as a safety net for any letterboxed source.
  const thumb =
    video.thumbnails?.maxres ??
    video.thumbnails?.medium ??
    video.thumbnails?.high ??
    video.thumbnails?.default;

  return (
    <article className="video-card">
      <Link to={`/video/${slug}`} state={{ videoId: video.id }}>
        {thumb && (
          <img
            src={thumb.url}
            alt={video.title}
            loading="lazy"
            width={thumb.width}
            height={thumb.height}
            className="video-thumb"
          />
        )}
        <div className="video-info">
          <h3>{video.title}</h3>
          {video.publishedAt && (
            <time dateTime={video.publishedAt}>
              {new Date(video.publishedAt).toLocaleDateString()}
            </time>
          )}
        </div>
      </Link>
    </article>
  );
}
